export const styleContainer = {display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', alignContent: 'start'}
export const myStyle2={
    marginTop:'0px', 
    paddingTop:{xs:1, md:5}, 
    width:{xs:"100%",md:"10%"}, 
    maxHeight:{xs:"10%", md:"100%"}, 
    backgroundColor: "#31559f", 
    display:"flex", 
    flexDirection:{xs:"row", md:"column"}, 
    overflowX: {xs:'auto', md:"hidden"}, 
    maxWidth: {xs:'100%'}, 
    whiteSpace: {xs:'nowrap'}, 
    marginBottom: -2};
export const styleButton={marginLeft:1, marginRight:1, border:1, borderColor:"white", color:"white", marginBottom:1.5, maxHeight: {xs:"35px"}}
export const styleTextField={
    marginLeft:2, 
    border:1, 
    borderColor:"white", 
    color:"white", 
    marginBottom:1.5, 
    borderRadius:2, 
    display:{xs:"none"}}
export const containerPrincipal = {
    display:"flex",
    flexDirection:{xs:"column",md:"row"}}
export const styleTextFiltros = {
    fontSize:25, 
    marginLeft:2, 
    color:"white", 
    marginBottom:1.5, 
    display:{xs:"none"}, 
    textAlign:"center"}